import * as yup from "yup";

/**
 * @description - Validation schema for scope form
 */
export default yup.object({
  slug: yup.string().required(),
  description: yup.string().required(),
  debug_mode: yup.boolean(),
  organizationId: yup.number().required(),
});
